import { GlBadge, GlTooltipDirective } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { DETACHED_EVENT_TYPE, AUTO_DEVOPS_SOURCE, SCHEDULE_SOURCE, MERGE_TRAIN_EVENT_TYPE, MERGED_RESULT_EVENT_TYPE, PIPELINE_TYPE_BRANCH, PIPELINE_TYPE_TAG } from '../constants';
export default {
    name: 'HeaderBadges',
    components: {
        GlBadge
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        pipeline: {
            type: Object,
            required: true
        }
    },
    computed: {
        isScheduledPipeline () {
            return this.pipeline.source === SCHEDULE_SOURCE;
        },
        mergeRequestEventType () {
            return this.pipeline.mergeRequestEventType;
        },
        isMergeTrainPipeline () {
            return this.mergeRequestEventType === MERGE_TRAIN_EVENT_TYPE;
        },
        isMergedResultsPipeline () {
            return this.mergeRequestEventType === MERGED_RESULT_EVENT_TYPE;
        },
        isBranchPipeline () {
            return this.pipeline.type === PIPELINE_TYPE_BRANCH;
        },
        isTagPipeline () {
            return this.pipeline.type === PIPELINE_TYPE_TAG;
        },
        isDetachedPipeline () {
            return this.mergeRequestEventType === DETACHED_EVENT_TYPE;
        },
        failureReason () {
            return this.pipeline.failureReason;
        },
        hasPipelineErrorMessages () {
            return this.pipeline?.errorMessages?.nodes?.length;
        },
        isAutoDevopsPipeline () {
            return this.pipeline.configSource === AUTO_DEVOPS_SOURCE;
        },
        yamlErrorMessage () {
            return this.pipeline?.errorMessages.nodes[0].content || '';
        },
        badges () {
            return {
                schedule: this.isScheduledPipeline,
                trigger: this.pipeline.trigger,
                invalid: this.hasPipelineErrorMessages,
                child: this.pipeline.child,
                latest: this.pipeline.latest,
                mergeTrainPipeline: this.isMergeTrainPipeline,
                mergedResultsPipeline: this.isMergedResultsPipeline,
                branchPipeline: this.isBranchPipeline,
                tagPipeline: this.isTagPipeline,
                detached: this.isDetachedPipeline,
                failed: Boolean(this.failureReason),
                autoDevops: this.isAutoDevopsPipeline,
                stuck: this.pipeline.stuck
            };
        }
    },
    buttonClass: '!gl-cursor-default gl-rounded-pill gl-border-none gl-bg-transparent gl-p-0'
};
